import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import WifiIcon from '@mui/icons-material/Wifi';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useNavigate } from 'react-router';
import { sensorTypeDetails } from '../../utils/sensorProperties';
import navigationStyles from '../../styles/navigationDrawer';
import useStyles from '../../styles/location';
import { SensorLatest, VarName } from '../../services/api';
import { themeProps } from '../../styles/theme';
import { getDataBandParams } from '../../utils/dataBandParams';

interface ConfiguredSensorsListProps {
  allSensors: SensorLatest[];
}

function ConfiguredSensorsList({ allSensors }: ConfiguredSensorsListProps): JSX.Element {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { classes: navigationClasses } = navigationStyles();
  return (
    <Box>
      {allSensors?.map((sensor) => {
        const isEnabled = !!sensor?.gateway;
        const typeDetails = sensor?.type ? sensorTypeDetails[sensor.type] : null;

        const Icon: typeof SvgIcon = typeDetails?.icon ?? WifiIcon;
        const TooltipText = typeDetails?.label ?? 'Wifi';

        const onlineStatusValue = sensor?.data?.find(
          (d) => d.varName === VarName.OnlineStatus
        )?.value;

        const sensorStatusBandParams =
          isEnabled && onlineStatusValue !== undefined
            ? getDataBandParams(VarName.OnlineStatus, onlineStatusValue)
            : null;

        const sensorStatusColor = sensorStatusBandParams?.color ?? themeProps.colors.grey;
        const sensorStatusDescription =
          sensorStatusBandParams?.label ?? (isEnabled ? 'Unknown' : 'Disabled');

        if (sensor.id) {
          const handleClick = () => {
            navigate(`/sensors/${sensor.id}`);
          };

          return (
            <Grid
              container
              className={classes.sensorList}
              key={sensor.id}
              onClick={handleClick}
              wrap="nowrap"
            >
              <Grid size={{ md: 1, sm: 2, xs: 2 }} sx={{ padding: '0' }}>
                <Icon className={classes.icon} />
              </Grid>
              <Grid size={{ md: 5, sm: 4, xs: 4 }} className={classes.sensorGridItem}>
                <Typography variant="body1">{sensor?.name}</Typography>
              </Grid>
              <Grid
                size={{ md: 6, sm: 6, xs: 6 }}
                sx={{ display: 'flex', alignItems: 'center', background: 'none' }}
                className={navigationClasses.navLink}
              >
                <Tooltip title={sensorStatusDescription}>
                  <FiberManualRecordIcon
                    style={{
                      marginRight: '5px',
                      color: sensorStatusColor,
                    }}
                  />
                </Tooltip>
                <Tooltip title={TooltipText}>
                  <Typography variant="body1">{sensor?.id}</Typography>
                </Tooltip>
              </Grid>
            </Grid>
          );
        }
        return null;
      })}
    </Box>
  );
}

export default ConfiguredSensorsList;
